<script>
const timeOptions = ["周一", "周二", "周三", "周四", "周五", "周六", "周日"];
export default {
  name: "driverWithdrawal",
  props: {
    rowData: {
      type: Object,
      default: () => {
        return {};
      },
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      form: {
        windowPhase: [],
        applyEnd: "",
        applyStart: "",
      },
      checkAll: false,
      isIndeterminate: false,
    };
  },
  computed: {
    rules() {
      return {
        earningsFreeze: [
          { required: true, message: "请选择收益冻结期", trigger: "change" },
        ],
        earningsFreezeTime: [
          {
            required: this.form.earningsFreeze == 1,
            message: "请输入收益冻结",
            trigger: "blur",
          },
        ],
        windowPhase: [
          { required: true, message: "请选择提现日期窗口", trigger: "change" },
        ],
        applyStart: [
          { required: true, message: "请选择提现时间窗口", trigger: "change" },
        ],
        applyEnd: [
          { required: true, message: "请选择提现时间窗口", trigger: "change" },
        ],
        applyNum: [
          { required: true, message: "请输入每日提现次数", trigger: "change" },
        ],
        applyAmountMin: [
          { required: true, message: "请输入单次提现限额", trigger: "change" },
        ],
        applyAmountMax: [
          { required: true, message: "请输入单次提现限额", trigger: "change" },
          {
            validator: (rule, value, callback) => {
              if (Number(value) < Number(this.form.applyAmountMin)) {
                callback(new Error("单次提现限额不能大于每日提现限额"));
              } else {
                callback();
              }
            },
            trigger: "change",
          },
        ],
      };
    },
  },
  mounted() {
    this.form = {
      ...this.rowData,
      earningsFreeze: this.rowData.earningsFreeze || 2,
      windowPhase: this.rowData.windowPhase
        ? this.rowData.windowPhase.split("、")
        : [],
      applyStart: this.rowData.applyStartTime ? this.rowData.applyStartTime : '00:00',
      applyEnd: this.rowData.applyEndTime ? this.rowData.applyEndTime : '23:00',
      applyNum: this.rowData.applyNum || 1,
      type: this.type
    };
    this.check(this.form.windowPhase);
    this.$nextTick(() => {
      this.$refs.form.clearValidate();
    });
  },
  methods: {
    handleCheckAllChange(val) {
      this.form.windowPhase = val ? timeOptions : [];
      this.isIndeterminate = false;
    },
    check(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === timeOptions.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < timeOptions.length;
    },
    saveClick() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const sortedDaysOfWeek = this.form.windowPhase.sort((a, b) => {
            const week = {
              周一: 1,
              周二: 2,
              周三: 3,
              周四: 4,
              周五: 5,
              周六: 6,
              周日: 7,
            };
            return week[a] - week[b];
          });
          let url = "/api/v1/manage/airport/withdrawalConfig";
          let data = await this.$axios.post(url, {
            ...this.form,
            windowPhase: sortedDaysOfWeek.join("、"),
            applyStartTime: this.form.applyStart,
            applyEndTime: this.form.applyEnd,
          });
          if (data && data.code === 1) {
            this.$message.success("保存成功");
            this.$emit("handClose");
          }
        } else {
          this.$message.warning("请检查表单数据是否输入正确！");
          return false;
        }
      });
    },
  },
};
</script>

<template>
  <div class="driverWithdrawal">
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item label="收益冻结期" prop="earningsFreeze">
        <div style="margin-bottom: 10px">
            <el-radio-group v-model="form.earningsFreeze">
              <el-radio :label="1">开启冻结</el-radio>
              <el-radio :label="2">停用冻结</el-radio>
            </el-radio-group>
          </div>
      </el-form-item>
      <el-form-item label="" prop="earningsFreezeTime">
        <div>
          <div>
            <el-input
              v-model="form.earningsFreezeTime"
              maxlength="6"
              v-input-filter="{ min: 1, max: 31, precision: 0 }"
              placeholder="最低收益冻结期"
              style="width: 205px"
              :disabled="form.earningsFreeze == 2"
            >
              <template slot="append">天</template>
            </el-input>
            <span
              class="el-form-item-remark"
              style="font-size: 12px; display: inline-block; padding-left: 8px"
              >获得收益后先冻结，到期才可提现，次日起记为第1天</span
            >
          </div>
        </div>
      </el-form-item>
      <el-form-item label="提现日期窗口" prop="windowPhase">
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选
        </el-checkbox>
        <el-checkbox-group @change="check" v-model="form.windowPhase">
          <el-checkbox label="周一">周一</el-checkbox>
          <el-checkbox label="周二">周二</el-checkbox>
          <el-checkbox label="周三">周三</el-checkbox>
          <el-checkbox label="周四">周四</el-checkbox>
          <el-checkbox label="周五">周五</el-checkbox>
          <el-checkbox label="周六">周六</el-checkbox>
          <el-checkbox label="周日">周日</el-checkbox>
        </el-checkbox-group>
      </el-form-item>

      <el-form-item label="提现时间窗口" prop="apply">
        <div style="display: flex;">
          <el-form-item label="" prop="applyStart">
          <el-time-select
          placeholder="起始时间"
          v-model="form.applyStart"
          :picker-options="{
            start: '00:00',
            step: '01:00',
            end: '23:00',
            maxTime: form.applyEnd
          }">
        </el-time-select>
      </el-form-item>

        <span style="margin: 0 10px;">至</span>
        <el-form-item label="" prop="applyEnd">
        <el-time-select
          placeholder="起始时间"
          v-model="form.applyEnd"
          :picker-options="{
            start: '00:00',
            step: '01:00',
            end: '23:00',
            minTime: form.applyStart
          }">
        </el-time-select>
      </el-form-item>
        </div>
        <!-- <el-time-picker
          style="width: 100%"
          is-range
          value-format="HH:mm"
          format="HH:mm"
          v-model="form.apply"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          placeholder="选择时间范围"
        >
        </el-time-picker> -->
      </el-form-item>

      <el-form-item label="每日提现次数" prop="applyNum">
        <el-input
          v-input-filter="{ min: 1, max: 10, precision: 0 }"
          v-model="form.applyNum"
          placeholder="请输入每日提现次数"
        >
          <template slot="append">次</template>
        </el-input>
      </el-form-item>
      <el-form-item label="单次提现限额" required>
        <div class="flex-start">
          <el-form-item
            style="margin-bottom: 0"
            label=""
            label-width="0px"
            prop="applyAmountMin"
          >
            <el-input
              v-input-filter="{ min: 1, max: 999999, precision: 0 }"
              v-model="form.applyAmountMin"
              placeholder=""
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <span style="padding: 0 10px">至</span>
          <el-form-item
            style="margin-bottom: 0"
            label=""
            label-width="0px"
            prop="applyAmountMax"
          >
            <el-input
              v-input-filter="{ min: 1, max: 999999, precision: 0 }"
              v-model="form.applyAmountMax"
              placeholder=""
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </div>
      </el-form-item>

      <el-form-item>
        <div class="flex-end">
          <el-button @click="$emit('handClose')">取消</el-button>
          <el-button type="primary" @click="saveClick">确定</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>

<style scoped lang="less">
</style>